module.exports = __webpack_public_path__ + "img/chuangyi.a52e5d1f.png";